module.exports = __webpack_public_path__ + "static/media/buy_user.4a7d303d.svg";